import { Divider, Stack, Typography } from '@mui/material';
import { LevelChip } from './ConditionApproval';
import { HierarchyLevels } from '@retail/products/types';
import { useCalculusTFunction } from '@retail/calculus/i18n';

interface RoundingConditionInfo {
  bindingType: HierarchyLevels;
  bindingTargetName: string;
  roundingRuleName: string;
}

interface Props {
  title: string;
  bindingType?: HierarchyLevels;
  bindingTarget: string;
  selectedPriceSuggestionType?: string;
  roundingCondition?: RoundingConditionInfo;
}

export function ConditionTooltipInfo({
  title,
  bindingType,
  bindingTarget,
  selectedPriceSuggestionType,
  roundingCondition,
}: Props) {
  const t = useCalculusTFunction();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">{title}</Typography>

      {bindingType && (
        <>
          <Stack flexDirection="row" alignItems="center" gap={2}>
            <Typography variant="body2">{t('calculus.level.level')}:</Typography>
            <LevelChip height={28} active bindingType={bindingType} />
          </Stack>
          {bindingType !== 'ASSORTMENT' && (
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography variant="body2">{t('calculus.level.levelOrItemName')}:</Typography>
              <Typography variant="subtitle2">{bindingTarget}</Typography>
            </Stack>
          )}
        </>
      )}
      {selectedPriceSuggestionType && (
        <Stack flexDirection="row" gap={1}>
          <Typography variant="body2">{t('calculus.priceType')}:</Typography>
          <Typography variant="subtitle2">{selectedPriceSuggestionType}</Typography>
        </Stack>
      )}

      {roundingCondition && (
        <>
          <Divider sx={{ my: 0.5 }} />
          <Stack flexDirection="row" alignItems="center" gap={2}>
            <Typography variant="body2">{t('calculus.level.level')}:</Typography>
            <LevelChip height={28} active bindingType={roundingCondition.bindingType} />
          </Stack>
          {roundingCondition.bindingType !== 'ASSORTMENT' && (
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Typography variant="body2">{t('calculus.level.levelOrItemName')}:</Typography>
              <Typography variant="subtitle2">{roundingCondition.bindingTargetName}</Typography>
            </Stack>
          )}
          <Stack flexDirection="row" gap={1}>
            <Typography variant="body2">{t('calculus.rounding.ruleSetName')}:</Typography>
            <Typography variant="subtitle2">{roundingCondition.roundingRuleName}</Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
}
